export default "__VITE_ASSET__CsQvH0Tn__"